<template>
  <div>
    <TitleName :TitleName="TitleName"></TitleName>
    <ul class="BottomContent_img_box" v-if="seenDataList.length > 0">
      <li
       @click="toDataInfo(item.dataId)"
        class="BottomContent_img"
        v-for="(item, index) in seenDataList.slice(0, 3)"
        :key="index"
      >
        <div class="BottomContent_img_con">
          <img :src="`${GLOBAL.imageUrl}${item.image}`" alt />
        </div>

        <div class="txt">{{ item.productName }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["seenDataList"],
  components: {
    TitleName: () => import("@/components/DataDetails/Other/TitleName.vue"),
  },
  data() {
    return {
      // TitleName: "看过数据的人还看了",
   
    };
  },
   computed:{
    TitleName(){
      return this.$t('DataDetails.lookOtherData')
    }
  },
  methods:{
     toDataInfo(dataId) {
      this.$router.push(`/datadetails?dataId=${dataId}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.BottomContent_img_box {
    border-top: 2px solid #fbfbfb;
    padding-top: 10px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  cursor: pointer;
  .BottomContent_img {
 
      margin-bottom: 16px;
    &:hover img {
      transition: 0.2s;
      transform: scale(1.2);
      opacity: 0.7;
    }
    .BottomContent_img_con {
      width: 100%;
      height: 140px;
      overflow: hidden;
      img {
          border: 1px solid #fbfbfb;
          border-radius: 4px;
        transition: 0.2s;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .txt {
             margin-top: 16px;
      font-size: 14px;
    //   font-weight: 600;
      color: #000000;
      line-height: 20px;
    }
  }
}
</style>